import { Box, CircularProgress, Typography } from '@mui/material';
import { FC } from 'react';
import { useTruckShiftUpdate } from 'src/contexts/TruckShiftUpdateContext';

// 稼働表(/truck-shifts)の更新処理（一括反映・一括解除・コピー）実行中に、全画面共通で右下に出す進捗表示。
// App レベルの TruckShiftUpdateProvider が保持する isUpdating を参照するため、稼働表から別画面へ
// 遷移しても処理が完了するまで出し続ける。
export const TruckShiftUpdateIndicator: FC = () => {
  const { isUpdating } = useTruckShiftUpdate();
  if (!isUpdating) return null;
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        position: 'fixed',
        bottom: 24,
        right: 24,
        zIndex: (theme) => theme.zIndex.snackbar + 10,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2,
        py: 1.25,
        borderRadius: 2,
        bgcolor: 'background.paper',
        color: 'text.primary',
        border: 1,
        borderColor: 'divider',
        boxShadow: '0 10px 30px -10px rgba(0,0,0,0.4)',
        minWidth: 240,
        animation: 'truckShiftUpdateIndicatorSlideUp 0.2s ease-out',
        '@keyframes truckShiftUpdateIndicatorSlideUp': {
          from: { opacity: 0, transform: 'translateY(8px)' },
          to: { opacity: 1, transform: 'translateY(0)' },
        },
      }}
    >
      <CircularProgress size={20} thickness={4} color="primary" />
      <Box sx={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>稼働表を更新中</Typography>
        <Typography variant="caption" color="text.secondary">しばらくお待ちください</Typography>
      </Box>
    </Box>
  );
};
